import { Container } from './style';

export function DotTypingLoader({ color = "#FFF" }) {
  return <Container color={color}/>
}

